import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { Button, Stack } from '@dtx-company/design-system/src'
import { CancelOutlined, DeleteOutline } from '@mui/icons-material'
import { FC } from 'react'
import { theme } from '@dtx-company/shared-components/src'
import styled from 'styled-components'

interface DeleteModeDrawerProps {
  deleteModeActive: boolean
  toggleDeleteMode: () => void
  onDelete: () => void
}

export const DeleteModeDrawer: FC<DeleteModeDrawerProps> = ({
  deleteModeActive,
  toggleDeleteMode,
  onDelete
}) => {
  return (
    <StyledDrawer expanded={deleteModeActive} data-testid="delete-mode-drawer">
      {deleteModeActive && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: '100%' }}
          gap="8px"
        >
          <Button fullWidth startIcon={DeleteOutline} onClick={onDelete}>
            Delete
          </Button>

          <Button fullWidth onClick={toggleDeleteMode} color="secondary" startIcon={CancelOutlined}>
            Cancel
          </Button>
        </Stack>
      )}
    </StyledDrawer>
  )
}

const StyledDrawer = styled(Box)<{ expanded: boolean }>`
  width: 100%;
  border-top: ${({ expanded }) =>
    expanded ? `1px solid ${theme.colors.secondary.border}` : 'none'};
  padding: ${({ expanded }) => (expanded ? '16px' : '0')};
  height: auto;
  max-height: ${({ expanded }) => (expanded ? '70px' : '0')};
  transition: max-height, 0.5s;
`

const StyledDrawerButton = styled.button<{ bg?: string; border?: string }>`
  type: button;
  cursor: pointer;
  border-radius: 4px;
  height: 40px;
  width: 100%;
  background: ${({ bg }) => bg};
  border: ${({ border }) => border};
  display: flex;
  align-items: center;
  justify-content: center;
  &:focus {
    outline: 2px solid rgba(3, 61, 221, 0.5);
  }
  &:hover {
    opacity: 0.5;
  }
`
